import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
// import { NotificationInfo, UserInfo } from "../../../context";

const MerchantCreateProduct = ({
  open,
  close,
  setLoading,
  getProductList,
  categoryList,
  subCategoryList,
  limit,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [fileList, setFileList] = useState([{}]);
  const [isSRPOff, setIsSRPOff] = useState(false);
  const [selectedIsPcs, setSelectedIsPcs] = useState(1);
  const [selectedIsVariant, setSelectedIsVariant] = useState(0);

  const handleSaveToProduct = (values) => {
    // console.log("values", values);
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("limit", limit);
    formdata.append("image", values.file.file);
    formdata.append("has_variant", selectedIsVariant);
    formdata.append(
      "is_per_piece",
      parseInt(selectedIsVariant) === 1 ? 0 : selectedIsPcs
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "exceed-limit") {
          rerunNotif("error", "Exceed limit.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Saved to product successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleChange = (info) => {
    // console.log(info);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    // console.log("fileList", fileList);
    setFileList(fileList);
  };

  return (
    <Drawer
      title="Create Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-products"
        initialValues={{
          product: "",
          description: "",
          price: "",
          // is_per_piece: selectedIsPcs,
          // has_variant: selectedIsVariant,
        }}
        onFinish={handleSaveToProduct}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="file"
            rules={[
              {
                required: true,
                message: "Product image required",
              },
            ]}
          >
            <Upload
              beforeUpload={({ fileList: newFileList }) => {
                // setFileList(newFileList);
                return false;
              }}
              onChange={handleChange}
              multiple={false}
              listType="picture-card"
              maxCount={1}
              // defaultFileList={[]}
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={fileList}
              // previewFile={false}
            >
              {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
              Upload
            </Upload>
          </Form.Item>

          <Form.Item
            name="product"
            label="Product Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set product name" size="large" />
          </Form.Item>

          <Form.Item name="description" label="Product Description">
            <Input placeholder="Set product description" size="large" />
          </Form.Item>

          <Form.Item
            name="category"
            label="Category"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select category"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoryList.data.length > 0 ? (
                categoryList.data.map((data, index) => (
                  <Select.Option value={data.id} key={index}>
                    {data.category}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No category found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          {userData.data.usersmerpermission.find(
            ({ permission }) => permission === "allow-sub-category"
          ) && (
            <Form.Item
              name="sub_category"
              label="Station"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select sub category"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {subCategoryList.data.length > 0 ? (
                  subCategoryList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.sub_category}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No sub category found!</Select.Option>
                )}
              </Select>
            </Form.Item>
          )}

          {userData.data.usersmerpermission.find(
            ({ permission }) => permission === "allow-product-variant"
          ) ? (
            <>
              <Form.Item
                // name="has_variant"
                label="Has Variant"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => setSelectedIsVariant(e)}
                  defaultValue={selectedIsVariant}
                >
                  <Select.Option value={0}>No</Select.Option>
                  <Select.Option value={1}>Yes</Select.Option>
                </Select>
              </Form.Item>
              {parseInt(selectedIsVariant) === 0 && (
                <>
                  {userData.data.usersmerpermission.find(
                    ({ permission }) => permission === "allow-product-per-kilo"
                  ) && (
                    <>
                      <Form.Item
                        // name="is_per_piece"
                        label="Consumption Unit?"
                        rules={[
                          {
                            required: true,
                            message: "Required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select"
                          size="large"
                          showSearch
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={(e) => setSelectedIsPcs(e)}
                          defaultValue={selectedIsPcs}
                        >
                          <Select.Option value={0}>Per Gram(s)</Select.Option>
                          <Select.Option value={1}>Per Piece(s)</Select.Option>
                        </Select>
                      </Form.Item>

                      {parseInt(selectedIsPcs) === 1 && (
                        <>
                          <Form.Item
                            name="purchase_srp"
                            label="Purchase SRP"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              max={999999999999}
                              initialvalues={0}
                              size="large"
                              style={{ width: "100%" }}
                              step="0.01"
                            />
                          </Form.Item>

                          <Form.Item
                            name="srp"
                            label="SRP"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              max={999999999999}
                              initialvalues={0}
                              size="large"
                              style={{ width: "100%" }}
                              step="0.01"
                            />
                          </Form.Item>

                          <Form.Item
                            name="is_srp_off"
                            label="Allow SRP off"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select"
                              size="large"
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(e) => setIsSRPOff(e)}
                            >
                              <Select.Option value={0}>No</Select.Option>
                              <Select.Option value={1}>Yes</Select.Option>
                            </Select>
                          </Form.Item>

                          {parseInt(isSRPOff) === 1 && (
                            <Form.Item
                              name="before_srp"
                              label="Before SRP"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                              />
                            </Form.Item>
                          )}
                        </>
                      )}

                      {parseInt(selectedIsPcs) === 0 && (
                        <>
                          <Form.Item
                            name="gram_consumption"
                            label="Gram(s) Consumption"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              max={999999999999}
                              initialvalues={0}
                              size="large"
                              style={{ width: "100%" }}
                              // onChange={(e) => console.log("CONSUMPTION: ", e)}
                              step="1"
                            />
                          </Form.Item>

                          <Form.Item
                            name="srp"
                            label="SRP"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              max={999999999999}
                              initialvalues={0}
                              size="large"
                              style={{ width: "100%" }}
                              step="0.01"
                            />
                          </Form.Item>

                          <Form.Item
                            name="is_srp_off"
                            label="Allow SRP off"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select"
                              size="large"
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(e) => setIsSRPOff(e)}
                            >
                              <Select.Option value={0}>No</Select.Option>
                              <Select.Option value={1}>Yes</Select.Option>
                            </Select>
                          </Form.Item>

                          {parseInt(isSRPOff) === 1 && (
                            <Form.Item
                              name="before_srp"
                              label="Before SRP"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                              />
                            </Form.Item>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <Form.Item
                name="purchase_srp"
                label="Purchase SRP"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                />
              </Form.Item>

              <Form.Item
                name="srp"
                label="SRP"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                />
              </Form.Item>

              <Form.Item
                name="is_srp_off"
                label="Allow SRP off"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => setIsSRPOff(e)}
                >
                  <Select.Option value={0}>No</Select.Option>
                  <Select.Option value={1}>Yes</Select.Option>
                </Select>
              </Form.Item>

              {parseInt(isSRPOff) === 1 && (
                <Form.Item
                  name="before_srp"
                  label="Before SRP"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                  />
                </Form.Item>
              )}
            </>
          )}

          <Form.Item
            name="is_fast_moving"
            label="Set as hot"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="is_best_seller"
            label="Set as Best Seller"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option value={0}>No</Select.Option>
              <Select.Option value={1}>Yes</Select.Option>
            </Select>
          </Form.Item>

          {parseInt(selectedIsVariant) === 0 && (
            <Form.Item
              name="allow_discount"
              label="Allow Discount"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>
          )}
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantCreateProduct;
